import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.principal.search.sortFields,
	columnFields: constants.principal.search.columnFields,
	standardFilterFields: constants.principal.search.standardFilterFields,
	dateFilterFields: [] as const,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
